/**
 * External dependencies
 */
import fastDeepEqual from 'fast-deep-equal/es6/index.js';

/**
 * WordPress dependencies
 */
import { useState, useRef } from '@wordpress/element';
import { createHigherOrderComponent, useIsomorphicLayoutEffect } from '@wordpress/compose';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default mapNodeToProps => createHigherOrderComponent(WrappedComponent => {
  return function WithFallbackStyles(props) {
    const [fallbackStyles, setFallbackStyles] = useState(undefined);
    const nodeRef = useRef(null);

    // Runs before paint, so the fallback styles apply without a flash.
    useIsomorphicLayoutEffect(() => {
      const node = props.node ?? nodeRef.current;
      // Derived from fallbackStyles: the grab is complete once every
      // mapped value has resolved to a truthy style.
      const grabStylesCompleted = !!fallbackStyles && Object.values(fallbackStyles).every(Boolean);
      if (node && !grabStylesCompleted) {
        const newFallbackStyles = mapNodeToProps(node, props);
        if (!fastDeepEqual(newFallbackStyles, fallbackStyles)) {
          setFallbackStyles(newFallbackStyles);
        }
      }
    });
    const wrappedComponent = /*#__PURE__*/_jsx(WrappedComponent, {
      ...props,
      ...fallbackStyles
    });
    return props.node ? wrappedComponent : /*#__PURE__*/_jsxs("div", {
      ref: nodeRef,
      children: [" ", wrappedComponent, " "]
    });
  };
}, 'withFallbackStyles');